<div mat-dialog-title class="d-flex align-items-center">
  <div class="d-flex align-items-center w-100">
    <h2 color="red" class="dhl-dialog-title">{{ dialogData.title ? dialogData.title : 'Confirmar' }}</h2>
  </div>
  <div class="flex-shrink-1">
    <div class="position-absolute top-0 end-0 p-2">
      <button mat-icon-button [mat-dialog-close]="false" color="accent">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col">
          <p class="fs-7 dhl-gray" weight="bolder">Folio de orden de compra ODC</p>
          <h4 color="black">
            <strong>{{ orderId }}</strong>
          </h4>
        </div>
      </div>
      <div class="row mb-3 mt-3">
        <div class="col">
          <div class="table-container">
            <mat-table [dataSource]="dataSource">
              <!-- Position Column -->
              <ng-container matColumnDef="date">
                <mat-header-cell *matHeaderCellDef matTooltip="Fecha">Fecha</mat-header-cell>
                <mat-cell *matCellDef="let element" [matTooltip]="element.date">{{ element.date }}</mat-cell>
                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="pay">
                <mat-header-cell *matHeaderCellDef matTooltip="Pago">Pago</mat-header-cell>
                <mat-cell *matCellDef="let element" [matTooltip]="element.pay">{{ element.pay }}</mat-cell>
                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="amount">
                <mat-header-cell *matHeaderCellDef matTooltip="Monto">Monto</mat-header-cell>
                <mat-cell *matCellDef="let element" [matTooltip]="element.amount">{{ element.amount }}</mat-cell>
                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="amountPaid">
                <mat-header-cell *matHeaderCellDef matTooltip="Monto Pagado">Monto Pagado</mat-header-cell>
                <mat-cell *matCellDef="let element" [matTooltip]="element.amountPaid">{{ element.amountPaid }}</mat-cell>
                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="balance">
                <mat-header-cell *matHeaderCellDef matTooltip="Saldo">Saldo</mat-header-cell>
                <mat-cell *matCellDef="let element" [matTooltip]="element.balance">{{ element.balance }}</mat-cell>
                <mat-footer-cell *matFooterCellDef></mat-footer-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns" (click)="selection.toggle(row)"> </mat-row>
              <mat-footer-row *matFooterRowDef="displayedColumns; sticky: false"></mat-footer-row>
            </mat-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions class="d-flex justify-content-end">
  <button
    *ngIf="dialogData.showCancel"
    mat-stroked-button
    color="accent"
    (click)="onCancel()"
    class="dhl-btn-secundary"
    [innerHTML]="dialogData.cancelLabel ? dialogData.cancelLabel : 'Cancelar'"></button>
  <button *ngIf="dialogData.showAccept" mat-flat-button cdkFocusInitial color="accent" (click)="onAccept()" class="dhl-btn-primary">
    {{ dialogData.acceptLabel ? dialogData.acceptLabel : 'Aceptar' }}
  </button>
</div>
